<template>
  <div>
    <div class="header">
      <div @click="$router.back()">
        <back />
      </div>
      <h3>Penilaian Manajemen Detail</h3>
    </div>

    <div class="body">
      <div class="manajemen" v-if="data.length > 0">
        <img :src="data[0].foto || 'https://img.icons8.com/?size=50&id=12438&format=png'" width="120px">
        <div>
          <h3>{{ data[0].nama }}</h3>
          <span>{{ data[0].jabatan }}</span>
        </div>
      </div>

      <div>
        <div class="rating" v-for="item, index in data" :key="index">
          <span v-for="star in stars" :class="{ 'filled': star.filled }" >
            ★
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Back from "./icons/Back.vue";
import * as api from "./../api/Api";

export default {
  components: {
    Back
  },
  data() {
    return {
      loading: false,
      data: [],
      stars: [
        { id: 1, filled: false },
        { id: 2, filled: false },
        { id: 3, filled: false },
        { id: 4, filled: false },
        { id: 5, filled: false }
      ],

    }
  },
  methods: {
    async load() {
      this.loading = true;

      const res = await api.get('/v1/kendali_kerja/penilaian_manajemen/get?id_manajemen=' + this.$route.params.id_manajemen);
      this.data = res.data

      this.loading = false;
    },
    detail(item) {
      setTimeout(() => {
        this.$router.push('/penilaian-manajemen/' + item.id)
      }, 150)
    }
  },
  mounted() {
    this.load();
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  z-index: 2;
  top: 0;
  left: calc(50% - 240px);
  width: 440px;
  display: flex;
  gap: 10px;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 15px 20px;
  background: #fff;

  @media screen and (max-width: 768px) {
    left: 0;
    width: 100%;
  }

  h3 {
    margin: 0;
  }

  .icon {
    height: 26px;
    display: flex;
    align-items: center;
  }
}

.body {
  padding: 20px;
  padding-top: 80px;
  padding-bottom: 100px;

  .manajemen {
    display: flex;
    align-items: center;

    h3 {
      margin-bottom: 0;
    }
  }
}

.rating {
  font-size: 24px;
}

.rating span {
  cursor: pointer;
}

.rating .filled {
  color: gold;
}

.skeleton-wrapper {
  margin-top: 20px;

  .skeleton {
    min-height: 65px;
    border-radius: 4px;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PenilaianManajemenDetail.vue